class MamProductDescription extends HTMLElement {
  connectedCallback() {
    if (this.dataset.enhanced) return;
    let host = this;
    while (
      host.children.length === 1 &&
      host.firstElementChild.tagName === 'DIV' &&
      [...host.childNodes].every(node => node.nodeType === Node.ELEMENT_NODE || !node.textContent.trim())
    ) host = host.firstElementChild;
    host.classList.add('mam-description-host');
    const nodes = [...host.childNodes];
    const headings = nodes.filter(node => node.nodeType === Node.ELEMENT_NODE && node.tagName === 'H2');
    if (headings.length) {
      const fragment = document.createDocumentFragment();
      const intro = document.createElement('div');
      intro.className = 'mam-description-intro';
      fragment.append(intro);
      let body = intro;
      for (const node of nodes) {
        if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'H2') {
          const panel = document.createElement('section');
          panel.className = 'mam-description-panel';
          const summary = document.createElement('header');
          summary.className = 'mam-description-summary';
          summary.append(node);
          body = document.createElement('div');
          body.className = 'mam-description-body';
          panel.append(summary, body);
          fragment.append(panel);
        } else body.append(node);
      }
      if (!intro.textContent.trim() && !intro.querySelector('img,video,table')) intro.remove();
      host.replaceChildren(fragment);
    }
    for (const table of host.querySelectorAll('table')) {
      if (table.parentElement.classList.contains('mam-table-scroll')) continue;
      const scroll = document.createElement('div');
      scroll.className = 'mam-table-scroll';
      table.before(scroll);
      scroll.append(table);
    }
    this.dataset.enhanced = 'true';
  }
}

if (!customElements.get('mam-product-description')) customElements.define('mam-product-description', MamProductDescription);

(() => {
  let observer;
  let widgetRoot;
  let syncDeliveryState;
  const enhanceDeliveryTargets = page => {
    const root = page.querySelector('#delivery-widget')?.shadowRoot;
    const input = root?.querySelector('.sr-pincode-input');
    const button = root?.querySelector('.sr-check-btn');
    if (!input || !button) return false;
    observer?.disconnect();
    if (widgetRoot !== root) {
      let disabledByLoading = false;
      const loaders = [root.querySelector('.sr-loader'), root.querySelector('.sr-loader-dot')];
      syncDeliveryState = () => {
        if (!input.getAttribute('aria-label') && !input.getAttribute('aria-labelledby')) {
          input.setAttribute('aria-label', input.placeholder || 'Enter pincode to check');
        }
        const loading = input.disabled || loaders.some(node => node?.style.display && node.style.display !== 'none');
        if (loading && !button.disabled) {
          disabledByLoading = true;
          button.disabled = true;
        } else if (!loading && disabledByLoading) {
          disabledByLoading = false;
          button.disabled = false;
        }
      };
      widgetRoot = root;
    }
    if (!root.querySelector('[data-mam-delivery-targets]')) {
      const style = document.createElement('style');
      style.dataset.mamDeliveryTargets = 'true';
      style.textContent = `
        .sr-delivery-widget .sr-input-group {
          height: 44px !important;
          min-height: 44px !important;
        }
        .sr-delivery-widget .sr-input-group .sr-pincode-input {
          box-sizing: border-box !important;
          width: calc(100% - 64px) !important;
          height: 44px !important;
          min-width: 0 !important;
        }
        .sr-delivery-widget .sr-input-group .sr-check-btn {
          box-sizing: border-box !important;
          width: 56px !important;
          height: 44px !important;
        }
      `;
      root.append(style);
      root.addEventListener('paste', event => {
        if (event.target?.matches?.('.sr-pincode-input')) event.stopImmediatePropagation();
      }, true);
    }
    syncDeliveryState();
    observer = new MutationObserver(syncDeliveryState);
    observer.observe(root, { subtree: true, attributes: true, attributeFilter: ['disabled', 'style'] });
    return true;
  };
  const watchDeliveryTargets = () => {
    observer?.disconnect();
    const page = document.querySelector('.mam-product-page');
    if (!page || enhanceDeliveryTargets(page)) return;
    observer = new MutationObserver(() => enhanceDeliveryTargets(page));
    observer.observe(page, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
  };
  watchDeliveryTargets();
  document.addEventListener('shopify:section:load', watchDeliveryTargets);
  window.addEventListener('pageshow', watchDeliveryTargets);
  window.addEventListener('pagehide', () => observer?.disconnect());
})();

(() => {
 let request, version=0;
 document.addEventListener('variant:update', async event => {
  const current=document.querySelector('[data-mam-pack-details]');
  const id=event.detail?.resource?.id;
  if(!current||current.dataset.mamMerged!=='true'||!id||String(event.detail?.data?.productId)!==current.dataset.productId||String(id)===current.dataset.variantId)return;
  request?.abort();request=new AbortController();const token=++version;
  const url=new URL(current.dataset.productUrl,location.origin);url.searchParams.set('variant',String(id));url.searchParams.set('section_id',current.dataset.sectionId);current.setAttribute('aria-busy','true');
  try{const response=await fetch(url,{signal:request.signal,headers:{Accept:'text/html'}});if(!response.ok)throw new Error('Pack details unavailable');const doc=new DOMParser().parseFromString(await response.text(),'text/html');const next=doc.querySelector('[data-mam-pack-details]');if(token===version&&next&&next.dataset.variantId===String(id))current.replaceWith(next);}
  catch(error){if(error.name!=='AbortError'&&token===version){const link=document.createElement('a');const retry=new URL(current.dataset.productUrl,location.origin);retry.searchParams.set('variant',String(id));link.href=retry.pathname+retry.search;link.textContent=window.mamCatalogText?.('details')||'View details for the selected pack';current.replaceChildren(link);}}
  finally{if(token===version)current.removeAttribute('aria-busy');}
 });
})();
